import SalesOrderViewStore from "./SalesOrderViewStore";

const purchasingStoreList = [
  { name: "salesOrderViewStore", store: SalesOrderViewStore },
];

export default purchasingStoreList;
